module.exports = __webpack_public_path__ + "static/media/corporate-services-img1.da7e916d.jpg";